"use client";

import { cn } from "@saridana-core/react-ui-kit";
import { TGridInfoSection } from "@shared/types";
import { ContentCard, CtaCard, SectionHeading } from "@shared/ui";

export function GridInfoSection({
  title,
  description,
  titleClassName,
  items,
  cta,
  cols = 3,
  descriptionClassName,
}: TGridInfoSection & { titleClassName?: string; descriptionClassName?: string }) {
  const randomNumber = Math.random();

  const colsMapping = ["lg:grid-cols-1", "lg:grid-cols-2", "lg:grid-cols-3", "lg:grid-cols-4", "lg:grid-cols-5", "lg:grid-cols-6"];

  return (
    <section className="py-20 sm:py-[100px] md:py-[120px] relative overflow-hidden bg-white">
      <div className="container relative">
        <SectionHeading
          className="text-center"
          title={title}
          titleClassName={"max-w-3xl " + titleClassName}
          description={description}
          descriptionClassName={"max-w-3xl mx-auto " + descriptionClassName}
        />
        {items && items.length > 0 && (
          <div className={cn("mt-14 md:mt-[72px] grid grid-cols-1 gap-6", colsMapping[cols - 1])}>
            {items.map((item) => {
              return (
                <ContentCard
                  key={"grid-info-content-card-" + randomNumber + "-" + item.id}
                  {...item}
                  className="text-center"
                  iconClassName="mx-auto"
                />
              );
            })}
          </div>
        )}

        {cta && (
          <div className="mt-10 md:mt-20">
            <CtaCard {...cta} />
          </div>
        )}
      </div>
    </section>
  );
}
